// @ts-nocheck
import Tooltip from "@insite/mobius/Tooltip";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import React, { FC, useState } from "react";

const StyleguideTooltips: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Tooltips" sectionId={sectionId}>
            <Tooltip text="Lorem Ipsum Dolor Sit Amet !" />
        </StyleguideSection>
    );
};

export default StyleguideTooltips;
